module.exports = __webpack_public_path__ + "img/45-doctor.2741f3fc.svg";